import React, { useEffect, useState, useMemo, useCallback } from "react";
import { getRolUser, anullUserRol, enableUserRol } from "../../interpreter/role";
import AppDataTable from "./AppDataTable";
import Icon from "@mdi/react";
import {
  mdiShieldAccountOutline,
  mdiAccountOffOutline,
  mdiAccountCheckOutline,
} from "@mdi/js";
import { permissionTranslations } from "../../services/diccionaryRole";
import "./AppDataTable.css";

const getStatusBadge = (status) => {
  const active = parseInt(status, 10) === 1;
  return (
    <span className={`table-badge ${active ? "table-badge--active" : "table-badge--muted"}`}>
      {active ? "Activo" : "Inactivo"}
    </span>
  );
};

export const RolesList = ({ roles, setRoles, openModal, refresh, onSuccess }) => {
  const [loading, setLoading] = useState(true);

  const fetchRoles = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getRolUser();
      if (data.succes === "2") {
        setRoles(data.user);
      } else if (data.succes === "1") {
        console.error("No existen datos de usuarios.");
      } else {
        console.error("Errores de conexión en el servidor.");
      }
    } catch (error) {
      console.error("Error en el Servidor", error);
    } finally {
      setLoading(false);
    }
  }, [setRoles]);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles, refresh]);

  const handleAnullUser = useCallback(async (id_users) => {
    try {
      const response = await anullUserRol(id_users);
      alert(response.message);
      onSuccess();
    } catch (err) {
      console.warn("Las siguientes fallas son:", err);
      return [];
    }
  }, [onSuccess]);

  const handleEnableUser = useCallback(async (id_users) => {
    try {
      const response = await enableUserRol(id_users);
      alert(response.message);
      onSuccess();
    } catch (err) {
      console.warn("Los siguientes errores son:", err);
      return null;
    }
  }, [onSuccess]);

  const columns = useMemo(() => [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      center: true,
      width: "70px",
      minWidth: "60px",
    },
    {
      name: "Correo",
      selector: (row) => row.email,
      sortable: true,
      center: true,
      wrap: true,
      grow: 2,
      minWidth: "140px",
    },
    {
      name: "Rol",
      selector: (row) =>
        Array.isArray(row.roles)
          ? (row.roles.length > 0 ? row.roles[0].name : "Sin rol")
          : (row.roles?.name || "Sin rol"),
      center: true,
      wrap: true,
      minWidth: "100px",
    },
    {
      name: "Permisos",
      cell: (row) => (
        <div className="table-cell--left text-sm leading-snug">
          {Array.isArray(row.permissions) && row.permissions.length > 0
            ? row.permissions.map((p, index) => (
                <div key={index}>{permissionTranslations[p.name] || p.name}</div>
              ))
            : "Sin permisos"}
        </div>
      ),
      wrap: true,
      grow: 3,
      minWidth: "140px",
    },
    {
      name: "Estado",
      cell: (row) => getStatusBadge(row.status),
      center: true,
      minWidth: "90px",
    },
    {
      name: "Acciones",
      cell: (row) => (
        <div className="table-actions table-actions--stack-sm">
          <button
            type="button"
            onClick={() => openModal("permiss", row)}
            className="table-action table-action--labeled table-action--primary"
            title="Gestionar permisos"
          >
            <Icon path={mdiShieldAccountOutline} size={0.95} />
            <span className="table-action__label">Permisos</span>
          </button>
          <button
            type="button"
            onClick={() => handleAnullUser(row.id)}
            className="table-action table-action--labeled table-action--danger"
            title="Desactivar usuario"
          >
            <Icon path={mdiAccountOffOutline} size={0.95} />
            <span className="table-action__label">Desactivar</span>
          </button>
          <button
            type="button"
            onClick={() => handleEnableUser(row.id)}
            className="table-action table-action--labeled table-action--success"
            title="Activar usuario"
          >
            <Icon path={mdiAccountCheckOutline} size={0.95} />
            <span className="table-action__label">Activar</span>
          </button>
        </div>
      ),
      center: true,
      minWidth: "200px",
      grow: 1,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ], [openModal, handleAnullUser, handleEnableUser]);

  return (
    <div>
      {loading ? (
        <div className="table-loading">
          <div className="table-loading__spinner" role="status" aria-label="Cargando usuarios" />
        </div>
      ) : (
        <AppDataTable
          title="Listado de Usuarios"
          columns={columns}
          data={roles}
        />
      )}
    </div>
  );
};
